export const saDownloadEvent = (eventName) => {
  if (window && window.sa_event) {
    return window.sa_event(eventName)
  } else {
    console.error('window.sa_event does not exist')
  }
}
